export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        businessType: '',
        feeTaskType: '',
        amount: '',
        taxAmount: '',
        remark: '',
        supplierComfirmAmount: '',
        stationName: ''
    },
    tableDataItems: [
        {
            prop: 'orderCode',
            label: '安装单号',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实际安装数量',
            type: 'normal'
        },
        {
            prop: 'businessTime',
            label: '完成时间',
            type: 'normal'
        },
        {
            prop: 'engineerCode',
            label: '工程师编码',
            type: 'normal'
        },
        {
            prop: 'engineerName',
            label: '工程师名称',
            type: 'normal'
        },
        {
            prop: 'engineerFee',
            label: '工程师费用',
            type: 'normal'
        },
        {
            prop: 'netFee',
            label: '网点费用',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '总费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '供应商确认费用',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '供应商备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '沟通回复',
            type: 'normal'
        }
    ],
    costTableDataItems: [
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'isEngineer',
            label: '是否工程师',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'customerNo',
            label: '客户单号',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'installationNo',
            label: '安装单号',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'customer',
            label: '客户',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'singleVolume',
            label: '单台体积(m³)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'singleGrossweight',
            label: '单台毛重(Kg)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'volume',
            label: '体积(m³)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'weight',
            label: '重量(Kg)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'actualQuantity',
            label: '实际安装数量',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'customerCommodityCode',
            label: '客户商品编码',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'commodityName',
            label: '商品名称',
            width: '200',
            type: 'normal'
        },
        {
            prop: 'commodityGroupCode',
            label: '商品分类编码',
            width: '140',
            type: 'normal'
        },
        {
            prop: 'commodityGroupName',
            label: '商品分类名称',
            width: '160',
            type: 'normal'
        },
        {
            prop: 'billingGroupTwo',
            label: '计费组2',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'billingGroupTwoName',
            label: '计费组2名称',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'price',
            label: '单价',
            width: '60',
            type: 'normal'
        },
        {
            prop: 'costExcludingTax',
            label: '不含税成本',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'taxAmount',
            label: '税额',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'costIncludingTax',
            label: '含税成本',
            width: '100',
            type: 'normal'
        }
    ]
};
